import Heading from "components/Heading/Heading";
import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import dayjs from "dayjs";
import {
  useAddBranchMutation,
  useDeleteBranchMutation,
  useEditBranchMutation,
  useGetBranchesQuery,
} from "../../../../../redux/Service/branches";

function Branches() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const {
    data: branchesData,
    isLoading: isBranchesLoading,
    isError: isBranchesError,
  } = useGetBranchesQuery(undefined);

  const branches = branchesData?.ResponseObject ?? [];

  const [deleteBranch, { isLoading: isDeleting }] = useDeleteBranchMutation();
  const [addBranch, { isLoading: isAdding }] = useAddBranchMutation();
  const [updateBranch, { isLoading: isUpdating }] = useEditBranchMutation();
  const handleDeletClick = (record: any) => {
    console.log(record);

    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الفرع "${record.BranchID}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteBranch(record.BranchID).unwrap();

          if (response?.ResponseObject == true) {
            message.success("تم حذف الفرع بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    {
      title: "كود الفرع",
      dataIndex: "BranchID",
      key: "BranchID",
    },
    {
      title: "اسم الفرع ",
      dataIndex: "BranchName",
      key: "BranchName",
    },
  ];

  const handleOk = async (values) => {
    const body = {
      ...values,
    };
    console.log("body", body);

    // return;

    try {
      let response;

      if (isEditing) {
        response = await updateBranch(body).unwrap(); // طلب التحديث
      } else {
        response = await addBranch(body).unwrap(); // طلب الإضافة
      }

      if (response?.ResponseObject == true) {
        message.success(
          isEditing ? "تم تعديل الفرع بنجاح" : "تمت إضافة الفرع بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);

    const recordData = { ...record };

    if (recordData.DocDate) {
      recordData.DocDate = dayjs(recordData.DocDate);
    }

    setTimeout(() => {
      form.setFieldsValue(recordData);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={branches}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeletClick}
          isLoading={isBranchesLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Branches;
